import React, { createContext, useMemo, useState, Dispatch, SetStateAction, ReactNode } from 'react';

type ThemeModeType = 'dark' | 'light';

type Preferences = {
  themeMode: ThemeModeType;
  setThemeMode: Dispatch<SetStateAction<ThemeModeType>>;
};

type Props = {
  children: ReactNode;
};

export const PreferencesContext = createContext<Preferences>({
  themeMode: 'dark',
  setThemeMode: mode => {},
});

const PreferencesProvider = ({ children }: Props) => {
  const [themeMode, setThemeMode] = useState<ThemeModeType>('dark');

  const preferences: Preferences = useMemo(() => {
    return { themeMode, setThemeMode };
  }, [themeMode]);

  return <PreferencesContext.Provider value={preferences}>{children}</PreferencesContext.Provider>;
};

export default PreferencesProvider;
